import {Typography} from '@mui/material';
import {FontWeight} from 'src/components/theme/orion/overrides/FontWeight';
import styled from 'styled-components';

export const BoldTypography = styled(Typography)
  .attrs((props) => ({...props, fontWeight: FontWeight.SemiBold}))``;
